import { FC } from "react";
import { IconDefinition } from "@fortawesome/free-solid-svg-icons";

export type TTitledIconChild = {
    title: string,
    icon: IconDefinition;
    isResults?: boolean;
    children?: JSX.Element | JSX.Element[];
    onClick?: () => void;
};

export const TitledIconChild: FC<TTitledIconChild> = ({ children }: TTitledIconChild) => {
    return (
        <>
            {children}
        </>
    );
}